export default __webpack_public_path__ + "static/fb-398b3bf460371d8155e6d44c3ab0c1d4.svg";